var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8618 1.3291C12.9664 1.3291 13.8618 2.22453 13.8618 3.3291C13.8617 4.43353 12.9663 5.3291 11.8618 5.3291C11.3316 5.32897 10.8505 5.12109 10.4927 4.78418L5.73486 7.55664C5.77031 7.70569 5.7915 7.86062 5.7915 8.02051C5.7915 8.14782 5.77713 8.27188 5.75439 8.39258L10.5347 11.1777C10.8878 10.8636 11.352 10.671 11.8618 10.6709C12.9663 10.6709 13.8616 11.5665 13.8618 12.6709C13.8618 13.7755 12.9664 14.6709 11.8618 14.6709C10.7575 14.6706 9.86279 13.7753 9.86279 12.6709C9.86282 12.5111 9.883 12.356 9.91846 12.207L5.18701 9.4502C4.82652 9.80212 4.33509 10.0205 3.7915 10.0205C2.68693 10.0205 1.7915 9.12508 1.7915 8.02051C1.7915 6.91594 2.68693 6.02051 3.7915 6.02051C4.30127 6.02051 4.76544 6.2124 5.11865 6.52637L9.90381 3.73828C9.87634 3.60622 9.86281 3.4693 9.86279 3.3291C9.86279 2.22469 10.7575 1.32937 11.8618 1.3291Z",
    fill: "#C1C7D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.16266d30d3ce0852db5fa10bc009b349.svg";
export { ForwardRef as ReactComponent };